<template>
  <div>
      <!-- <socialandcontact class="d-sm-none d-md-none d-lg-none"/> -->
      <FrontEndNav fixed/>
      <bannerforotherpages v-if="this.$route.name == 'PastFights'"/>
      <upcomingfightsbanner v-if="this.$route.name == 'UpcomingFights'"/>
      <currentfightsbanner v-if="this.$route.name == 'CurrentFights'"/>
      <banner v-if="this.$route.path == '/'"/>
  </div>
</template>

<script>
import FrontEndNav from "../navcomponents/FrontEndNav.vue"
import Banner from './banner.vue';
import bannerforotherpages from './bannerforotherpages.vue'
import upcomingfightsbanner from "./upcomingfightsbanner.vue"
import currentfightsbanner from './currentfightsbanner.vue'
// import Socialandcontact from './socialandcontact.vue';
export default {
    components: { FrontEndNav, Banner, bannerforotherpages, upcomingfightsbanner, currentfightsbanner }
}
</script>

<style>

</style>